export default __webpack_public_path__ + "static/media/BrainBreak cards74.307c217e.png";